import LogoutService from '../../authentication/logout/logout-service';

import { Auth0Wrapper } from './Auth0Wrapper';

class MultiSessionServiceClass {
  async handleCentralAuthLogin(loginInfo, isCurrentUserSysAdmin) {
    if (isCurrentUserSysAdmin) {
      return;
    }

    const claims = await Auth0Wrapper.getIdTokenClaims();
    const currentSessionId = claims?.[Auth0Wrapper.CLAIMS.IDS_SESSION_ID];
    const currentUserId = claims?.sub?.split('auth0|')[1];

    if (currentUserId === loginInfo.userId && currentSessionId !== loginInfo.sessionId) {
      const redirectTo = `${window.location.protocol}//${window.location.host}`;
      LogoutService.logout(redirectTo);
    }
  }
}

export const MultiSessionService = new MultiSessionServiceClass();
